module.exports = __webpack_public_path__ + "static/cmaw-logo-f635b057d7794715373faefe58770a42.jpg";